export default {"src":"/_next/static/media/white-chevron-left.81171b8b.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};